// `/distributors/$id/settings` — таб «Настройки» в карточке тенанта (PA-12,
// D17 §2.3). Layout-route `distributors.$id.tsx` даёт AdminShell, breadcrumb,
// TabBar и `redirectIfNotPlatformAdmin` (наследуется child'ом через TanStack
// Router `beforeLoad`).
//
// Состав:
//   - PlatformCredentialsSection (PA-14, D17 §2.5) — cross-tenant issue/revoke
//     exchange-credentials. Единственный mutation-блок в карточке PA.
//   - DistributorSettingsTabScreen (PA-12) — read-only снимок настроек тенанта
//     (бренд-имя, контакты, primaryColor, default price type). Полное
//     редактирование делает OWNER в /settings своего портала.

import { createFileRoute } from '@tanstack/react-router'
import { RequireAuth } from '@dss/auth'
import {
  DistributorSettingsTabScreen,
} from '../features/distributors/tabs/DistributorSettingsTabScreen'
import {
  PlatformCredentialsSection,
} from '../features/platform-exchange-credentials/PlatformCredentialsSection'

export const Route = createFileRoute('/distributors/$id/settings')({
  component: DistributorSettingsRoute,
})

function DistributorSettingsRoute() {
  const { id } = Route.useParams()
  const numericId = Number(id)
  if (!Number.isFinite(numericId)) {
    return (
      <RequireAuth>
        <div style={{ padding: 24, color: 'var(--color-text-secondary)' }}>
          Некорректный идентификатор дистрибьютора в URL.
        </div>
      </RequireAuth>
    )
  }
  return (
    <RequireAuth>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        <PlatformCredentialsSection distributorId={numericId} />
        <DistributorSettingsTabScreen distributorId={numericId} />
      </div>
    </RequireAuth>
  )
}
